module.exports = __webpack_public_path__ + "static/MF21UC-4da5a6e4551782e3870e2d8642f18e07.png";